// A JWT's payload read without verification: for display only, the APIs verify every token.

/** The claims of a JWT, or {} when it cannot be read. */
export function claimsOf(jwt: string | undefined): Record<string, unknown> {
  const payload = jwt?.split(".")[1];
  if (!payload) return {};
  try {
    const base64 = payload.replaceAll("-", "+").replaceAll("_", "/");
    const binary = atob(base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "="));
    const text = new TextDecoder().decode(Uint8Array.from(binary, (c) => c.charCodeAt(0)));
    const claims: unknown = JSON.parse(text);
    return claims && typeof claims === "object" && !Array.isArray(claims)
      ? (claims as Record<string, unknown>)
      : {};
  } catch {
    return {};
  }
}

/** The realm roles of an access token (Keycloak puts them there, not in the ID token). */
export const realmRolesOf = (jwt: string | undefined): unknown =>
  (claimsOf(jwt).realm_access as { roles?: unknown } | undefined)?.roles;
